import React from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";

const TrainingInfoBox = ({ description, note }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: 2.5,
        py: 2,
        mb: 3,
        backgroundColor: theme.customColors?.background?.info || "#F8F9FA",
        border: `1px solid ${theme.customColors?.border?.subtle || "#EEEEEE"}`,
        borderRadius: "8px",
      }}
    >
      {description && (
        <Typography
          variant="body2"
          sx={{
            color: theme.customColors?.text?.secondary || "#6B7280",
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>
      )}

      {description && note && (
        <Divider
          sx={{
            my: 1.5,
            borderColor: theme.customColors?.border?.subtle || "#EEEEEE",
          }}
        />
      )}

      {note && (
        <Typography
          variant="body2"
          sx={{
            color: theme.customColors?.text?.secondary || "#6B7280",
            lineHeight: 1.6,
            fontStyle: "italic",
          }}
        >
          <Box
            component="strong"
            sx={{
              fontWeight: 600,
              fontStyle: "normal",
              color: theme.customColors?.text?.strong || "#1A1A2E",
            }}
          >
            Note:
          </Box>{" "}
          {note}
        </Typography>
      )}
    </Box>
  );
};

export default TrainingInfoBox;
